import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ServiceQueueItemModel } from '@/libs/Api';
import { ServiceQueueItemsDataService } from '@/libs/service-queue-items/service-queue-items-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const serviceQueueItemsStore = registerCrudStore<ServiceQueueItemModel, ServiceQueueItemModel>(BusinessModule.ServiceQueueItem, new ServiceQueueItemsDataService());
